"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorrowerIdFromCreditAgreement = void 0;
const common_1 = require("@finley-technologies/common");
const getBorrowerIdFromCreditAgreement = (creditAgreement) => {
    const borrowers = creditAgreement.facilityMechanics.parties.borrowers;
    (0, common_1.finleyAssert)(borrowers.length === 1, `Only a single borrower can be configured for a credit facility, but found ${borrowers.length} borrowers in [creditAgreementId:${creditAgreement.id}] [creditFacilityId:${creditAgreement.creditFacilityId}]`);
    if ('entity' in borrowers[0]) {
        return borrowers[0].entity.id;
    }
    if ('_id_' in borrowers[0]) {
        return borrowers[0]._id_;
    }
    throw new common_1.error.FinleyError(`Unable to get borrowerId from [creditAgreementId:${creditAgreement.id}] [creditFacilityId:${creditAgreement.creditFacilityId}]`);
};
exports.getBorrowerIdFromCreditAgreement = getBorrowerIdFromCreditAgreement;
//# sourceMappingURL=get.js.map